<template>
  <v-dialog 
    v-model="navigation.CRMWhatsappInvoicesDialogIsVisible" 
    @update:model-value="navigation.CRMWhatsappInvoicesDialogIsVisible == false ? closeCRMWhatsappInvoicesDialog() : null" 
    max-width="80vw" 
    @contextmenu.prevent="null"
    style="user-select: none; cursor: default;"
  >    
    <v-card style="max-height: 95vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-invoice-text</v-icon>
            <h3>ÓRDENES</h3>
          </div>
          <div class="actionsContainer">
            <v-btn 
              @click="navigation.CRMWhatsappInvoicesDialogIsVisible = false"
              :disabled="loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog || loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogPagination"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
        <v-data-table 
          :headers="computed_CRMWhatsappInvoicesHeaders" 
          :items="display.CRMWhatsappInvoices"
          :loading="loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog"
          :items-per-page="-1" 
          density="compact"
          loading-text=""
          hover
          fixed-header
          style="min-height: 65vh; height: 65vh; max-height: 65vh; overflow-y: auto;"
        >
          <template v-slot:header.CRMWhatsappInvoiceID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-barcode</v-icon>
              <p><strong>ID</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappContactID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-account</v-icon>
              <p><strong>CONTACTO</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappInvoiceCreationDatetime>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-clock</v-icon>
              <p><strong>CREACIÓN</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappInvoiceAmount>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-cash</v-icon>
              <p><strong>MONTO{{ navigation.productCategoryID ? ' TOTAL' : '' }}</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappInvoiceProductCategoryAmount>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-cash</v-icon>
              <p><strong>MONTO{{ navigation.productCategoryID ? ` DE LA CATEGORÍA` : '' }}</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappInvoiceCreationCRMAgentID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-briefcase-account</v-icon>
              <p><strong>VENDEDOR</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappInvoiceShippingCRMAgentID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-truck</v-icon>
              <p><strong>AGENTE DE ENTREGA</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappInvoiceCRMLocalityID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-store</v-icon>
              <p><strong>LOCALIDAD</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappInvoiceProductsAction>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-package</v-icon>
              <p><strong>PRODUCTOS</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationAction>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-chat</v-icon>
              <p><strong>CONVERSACIÓN</strong></p>
            </div>
          </template>
          <template v-slot:item="row">
            <tr :class="loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogPagination ? 'loadingVDataTableRow' : null" :style="loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogPagination ? 'pointer-events: none;' : null">
              <td>
                <v-hover v-slot="{ isHovering, props: hoverProps }">
                  <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                    <v-tooltip v-bind="hoverProps" text="Copiar ID al portapapeles" location="top">
                      <template v-slot:activator="{ props: tooltipProps }">
                        <p v-bind="tooltipProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la orden', 'o', row.item.CRMWhatsappInvoiceID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappInvoiceID }}</strong></p>
                      </template>
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <p v-bind="hoverProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la orden', 'o', row.item.CRMWhatsappInvoiceID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappInvoiceID }}</strong></p>
                  </template>
                </v-hover>
              </td>
              <td>
                <div style="white-space: nowrap;">
                  <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                  <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
                </div>
              </td>
              <td>
                <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappInvoiceCreationDatetime) }}</p>
              </td>
              <td>
                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(Math.round((row.item.CRMWhatsappInvoiceAmount || 0) / 5) * 5) }}</p>
              </td>
              <td v-if="navigation.productCategoryID">
                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(Math.round((row.item.CRMWhatsappInvoiceProductCategoryAmount || 0) / 5) * 5) }}</p>
              </td>
              <td>
                <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID)">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentColor || 'primary'" elevation="2" variant="flat" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentName }}</p>
                    </div>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" elevation="2" variant="flat" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>No registrado</p>
                    </div>
                  </v-chip>
                </template>
              </td>
              <td v-if="navigation.CRMWhatsappInvoiceShippingCRMAgentID">
                <v-chip :color="row.item.ShippingCRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="row.item.ShippingCRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>{{ row.item.ShippingCRMAgentName || 'No registrado' }}</p>
                  </div>
                </v-chip>
              </td>
              <td>
                <template v-if="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappInvoiceCRMLocalityID)">
                  <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                    <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                      <div v-if="row.item.CRMWhatsappInvoiceCRMLocalityMapDivisionID" style="display: flex; align-items: center;">
                        <v-icon size="small" style="margin: 0px 5px;">mdi-arrow-right-bold</v-icon>
                        <p style="font-size: x-small;">{{ systemInformationData.CRMLocalities.flatMap(CRMLocality => CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions).find(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID == row.item.CRMWhatsappInvoiceCRMLocalityMapDivisionID) ? systemInformationData.CRMLocalities.flatMap(CRMLocality => CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions).find(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID == row.item.CRMWhatsappInvoiceCRMLocalityMapDivisionID).CRMLocalityMapDivisionName || 'No registrada' : 'No registrada' }}</p>
                      </div>
                    </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <p>No registrada</p>
                  </v-chip>
                </template>
              </td>
              <td>
                <v-btn @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([row.item.CRMWhatsappInvoiceID])" color="primary" class="hoverableText">
                  <v-icon size="small" style="margin-right: 10px;">mdi-package</v-icon>
                  <p style="font-size: small;">PRODUCTOS</p>
                </v-btn>
              </td>
              <td>
                <v-btn @click="$root.dialogComponent.openCRMWhatsappConversationDialog(row.item.CRMWhatsappInvoiceCRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, false, false)" color="primary" class="hoverableText">
                  <v-icon size="small" style="margin-right: 10px;">mdi-chat</v-icon>
                  <p style="font-size: small;">CONVERSACIÓN</p>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:loading>
            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; padding: 30px; gap: 10px;">
              <v-icon size="large" color="indigo">mdi-clock</v-icon>
              <p style="color: #9e9e9e;">Cargando lista de órdenes...</p>
            </div>
          </template>
          <template v-slot:no-data>
            <div style="text-align: center; padding: 15px; cursor: default; user-select: none;">
              <v-icon size="large" color="indigo">mdi-information</v-icon>
              <p style="margin-top: 10px; color: grey;">No existen órdenes en el rango de fecha seleccionado</p>
            </div>
          </template>
          <template v-slot:bottom></template>
        </v-data-table>
        <template v-if="display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount != null && display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount != 0">
          <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
          <v-card color="primary" elevation="0" rounded="0">
            <div class="dialogFooterContainer">
              <div class="summaryContainer">
                <div style="display: flex; align-items: center;">
                  <v-icon color="indigo" size="small" style="margin-right: 5px;">mdi-invoice-text</v-icon>
                  <p style="font-size: small; margin-right: 10px;"><strong>Órdenes: </strong>{{ display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount }}</p>
                  <v-tooltip :disabled="display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount == 0" location="top">
                    <template v-slot:activator="{ props }">
                      <v-chip v-bind="props" :color="(display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount == 0 ? 'grey' : ((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount) / display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount) >= 0 ? 'success' : 'error')" variant="flat" size="small" elevation="2" label class="hoverableText">
                        <v-icon :icon="(display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount == 0 ? 'mdi-trending-neutral' : ((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount) / display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                        <template v-if="display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount != 0">
                          <p style="font-size: x-small;"><strong>{{(((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount) / display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount) * 100).toFixed(2)}}%</strong></p>
                        </template>
                        <template v-else>
                          <p style="font-size: x-small;"><strong>Sin datos</strong></p>
                        </template>
                      </v-chip>
                    </template>
                    <div>
                      <p><strong>Órdenes:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount) }}</p>
                      <p><strong>Órdenes de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount) }}</p>
                      <p><strong>Diferencia:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount) }}</p>
                    </div>
                  </v-tooltip>
                </div>
                <div style="display: flex; align-items: center;">
                  <v-icon color="indigo" size="small" style="margin-right: 5px;">mdi-counter</v-icon>
                  <p style="font-size: small; margin-right: 10px;"><strong>Unidades: </strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) }}</p>
                  <v-tooltip :disabled="display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount == 0" location="top">
                    <template v-slot:activator="{ props }">
                      <v-chip v-bind="props" :color="(display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount == 0 ? 'grey' : ((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) / display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) >= 0 ? 'success' : 'error')" variant="flat" size="small" elevation="2" label class="hoverableText">
                        <v-icon :icon="(display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount == 0 ? 'mdi-trending-neutral' : ((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) / display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                        <template v-if="display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount != 0">
                          <p style="font-size: x-small;"><strong>{{(((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) / display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) * 100).toFixed(2)}}%</strong></p>
                        </template>
                        <template v-else>
                          <p style="font-size: x-small;"><strong>Sin datos</strong></p>
                        </template>
                      </v-chip>
                    </template>
                    <div>
                      <p><strong>Unidades:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) }}</p>
                      <p><strong>Unidades de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) }}</p>
                      <p><strong>Diferencia:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceProductAmount) }}</p>
                    </div>
                  </v-tooltip>
                </div>
                <div style="display: flex; align-items: center;">
                  <v-icon color="indigo" size="small" style="margin-right: 5px;">mdi-cash</v-icon>
                  <p style="font-size: small; margin-right: 10px;"><strong>Ventas: </strong>₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount || 0) / 5) * 5) }}</p>
                  <v-tooltip :disabled="display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount == 0" location="top">
                    <template v-slot:activator="{ props }">
                      <v-chip v-bind="props" :color="(display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount == 0 ? 'grey' : ((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount) / display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount) >= 0 ? 'success' : 'error')" variant="flat" size="small" elevation="2" label class="hoverableText">
                        <v-icon :icon="(display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount == 0 ? 'mdi-trending-neutral' : ((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount) / display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                        <template v-if="display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount != 0">
                          <p style="font-size: x-small;"><strong>{{(((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount) / display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount) * 100).toFixed(2)}}%</strong></p>
                        </template>
                        <template v-else>
                          <p style="font-size: x-small;"><strong>Sin datos</strong></p>
                        </template>
                      </v-chip>
                    </template>
                    <div>
                      <p><strong>Ventas:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount || 0) / 5) * 5) }}</p>
                      <p><strong>Ventas de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount || 0) / 5) * 5) }}</p>
                      <p><strong>Diferencia:</strong> {{ display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount > display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount - display.offsetCRMWhatsappInvoicesSummary.CRMWhatsappInvoiceAmount)) / 5) * 5) }}</p>
                    </div>
                  </v-tooltip>
                </div>
              </div>
              <div class="paginatorContainer">
                <v-pagination
                  v-model="navigation.page"
                  @update:model-value="selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog(false)"
                  :length="Math.ceil(display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount / navigation.limit)"
                  :total-visible="5"
                  :disabled="loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogPagination"
                  density="compact"
                  size="small"
                ></v-pagination>
                <p style="font-size: x-small;">{{ (display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount == 0) ? `0 de 0 órdenes` : `${(navigation.page - 1) * navigation.limit + 1} - ${Math.min(navigation.page * navigation.limit, display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount)} de ${display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount} ${display.CRMWhatsappInvoicesSummary.CRMWhatsappInvoicesCount > 1 ? 'órdenes' : 'orden'}`}}</p>
              </div>
            </div>
          </v-card>
        </template>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  
  .titleContainer {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .dialogFooterContainer {
    display: grid;
    align-items: center;
    grid-template-columns: 1.5fr 0.5fr;
    gap: 10px;
    padding: 10px;
  }

  .summaryContainer {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .paginatorContainer {
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 1200px) {
    .inputContainer {
      grid-template-columns: 1fr;
    }
    .fourColumnContainer {
      grid-template-columns: 1fr;
    }
    .notEvenlyDistributedTwoColumnContainer {
      grid-template-columns: 1fr;
    }
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .actionsContainer {
      justify-content: center;
      margin-left: 0;
    }
    .dialogFooterContainer {
      grid-template-columns: 1fr;
    }
    .summaryContainer {
      align-items: center;
      justify-content: center;
    }
    .paginatorContainer {
      justify-content: center;
      margin-left: 0;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      display:
      {
        CRMWhatsappInvoicesSummary: {},
        offsetCRMWhatsappInvoicesSummary: {},
        CRMWhatsappInvoices: []
      },
      navigation:
      {
        CRMWhatsappInvoicesDialogIsVisible: false,
        date: [],
        CRMAgentID: null,
        newCRMWhatsappContact: false,
        productCategoryID: null,
        CRMWhatsappInvoiceCreationHour: null,
        CRMWhatsappInvoiceCRMLocalityID: null,
        CRMWhatsappInvoiceCRMLocalityMapDivisionID: null,
        CRMWhatsappInvoiceShippingCRMAgentID: null,
        isCRMWhatsappContactFollowup: false,
        page: 1,
        limit: 50
      },
      loader:
      {
        selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog: false,
        selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogPagination: false
      },
      systemInformationData:
      {
        CRMAccountID: null,
        CRMAgents: [],
        CRMLocalities: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed:
    {
      computed_CRMWhatsappInvoicesHeaders() {
        const CRMWhatsappInvoicesHeaders =
        [
          {title: 'ID', key: 'CRMWhatsappInvoiceID', sortable: false},
          {title: 'CONTACTO', key: 'CRMWhatsappContactID', sortable: false},
          {title: 'CREACIÓN', key: 'CRMWhatsappInvoiceCreationDatetime', sortable: false},
          {title: 'MONTO', key: 'CRMWhatsappInvoiceAmount', sortable: false},
          ...(this.navigation.productCategoryID ? [{title: `MONTO DE LA CATEGORÍA`, key: 'CRMWhatsappInvoiceProductCategoryAmount', sortable: false}] : []),
          {title: 'VENDEDOR', key: 'CRMWhatsappInvoiceCreationCRMAgentID', sortable: false},
          ...(this.navigation.CRMWhatsappInvoiceShippingCRMAgentID ? [{title: 'AGENTE DE ENTREGA', key: 'CRMWhatsappInvoiceShippingCRMAgentID', sortable: false}] : []),
          {title: 'LOCALIDAD', key: 'CRMWhatsappInvoiceCRMLocalityID', sortable: false},
          {title: 'PRODUCTOS', key: 'CRMWhatsappInvoiceProductsAction', sortable: false},
          {title: 'CONVERSACIÓN', key: 'CRMWhatsappConversationAction', sortable: false}
        ]
        return CRMWhatsappInvoicesHeaders;
      },
    },

    methods:
    {
 
      async selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog(isNewSearch) {
        if (isNewSearch){
          this.navigation.page = 1;
          this.display.CRMWhatsappInvoicesSummary = {};
          this.display.CRMWhatsappInvoices.length = 0;
          this.loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog = true;
        }
        if (this.navigation.date.length == 0) this.navigation.date = [new Date()];
        this.loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogPagination = true;
        const selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.navigation.CRMAgentID,
            'CRMWhatsappInvoiceShippingCRMAgentID': this.navigation.CRMWhatsappInvoiceShippingCRMAgentID
          },
          'startDate': this.navigation.date[0],
          'endDate': this.navigation.date[this.navigation.date.length - 1],
          'newCRMWhatsappContact': this.navigation.newCRMWhatsappContact,
          'productCategoryID': this.navigation.productCategoryID,
          'CRMWhatsappInvoiceCreationHour': this.navigation.CRMWhatsappInvoiceCreationHour,
          'CRMWhatsappInvoiceCRMLocalityID': this.navigation.CRMWhatsappInvoiceCRMLocalityID,
          'CRMWhatsappInvoiceCRMLocalityMapDivisionID': this.navigation.CRMWhatsappInvoiceCRMLocalityMapDivisionID,
          'isCRMWhatsappContactFollowup': this.navigation.isCRMWhatsappContactFollowup,
          'page': this.navigation.page,
          'limit': this.navigation.limit
        };
        const selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappInvoice/functions/selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog', selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogRequestQuery);
        if (selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogResult.success) {
          this.display.CRMWhatsappInvoicesSummary = selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogResult.result.CRMWhatsappInvoicesSummary;
          this.display.offsetCRMWhatsappInvoicesSummary = selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogResult.result.offsetCRMWhatsappInvoicesSummary;
          this.display.CRMWhatsappInvoices = selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogResult.result.CRMWhatsappInvoices;
          this.loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog = false;
          this.loader.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialogPagination = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog_error', 'error', 'Ha ocurrido un error inesperado al consultar las órdenes, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeCRMWhatsappInvoicesDialog();
        }
      },

      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeCRMWhatsappInvoicesDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeCRMWhatsappInvoicesDialog();
        }
      },
      
      async openCRMWhatsappInvoicesDialog(date, CRMAgentID, newCRMWhatsappContact, productCategoryID, CRMWhatsappInvoiceCreationHour, CRMWhatsappInvoiceCRMLocalityID, CRMWhatsappInvoiceCRMLocalityMapDivisionID, CRMWhatsappInvoiceShippingCRMAgentID, isCRMWhatsappContactFollowup){
        await this.getSystemInformationData();
        this.navigation.CRMWhatsappInvoicesDialogIsVisible = true;
        this.navigation.date = date;
        this.navigation.CRMAgentID = CRMAgentID == 'null' ? null : CRMAgentID;
        this.navigation.newCRMWhatsappContact = newCRMWhatsappContact;
        this.navigation.productCategoryID = productCategoryID;
        this.navigation.CRMWhatsappInvoiceCreationHour = CRMWhatsappInvoiceCreationHour;
        this.navigation.CRMWhatsappInvoiceCRMLocalityID = CRMWhatsappInvoiceCRMLocalityID;
        this.navigation.CRMWhatsappInvoiceCRMLocalityMapDivisionID = CRMWhatsappInvoiceCRMLocalityMapDivisionID;
        this.navigation.CRMWhatsappInvoiceShippingCRMAgentID = CRMWhatsappInvoiceShippingCRMAgentID;
        this.navigation.isCRMWhatsappContactFollowup = isCRMWhatsappContactFollowup;
        await this.selectCRMWhatsappInvoicesFromCRMWhatsappInvoicesDialog(true);
      },

      closeCRMWhatsappInvoicesDialog(){
        this.navigation.CRMWhatsappInvoicesDialogIsVisible = false;
        if (this.systemInformationData.updateSubscription) systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
        this.$emit('closeCRMWhatsappInvoicesDialog');
      }
    }
  }
</script>